export default () => ({
    name: "",
    email: "",
    company: {
      id: null,
      name: ""
    },
    partnerId: null
});